import { useSelector } from "react-redux";

import DescriptionDetailsList from "@/shared/components/DescriptionDetailsList/DescriptionDetailsList";
import { RootState } from "@/store/store";
import formattedDate from "@/utils/formattedDate";
import { ISelectedpatientProps } from "@/shared/interfaces/patientPage";

export default function UserDetailsPageInfo({
    toggleDrawer,
}: ISelectedpatientProps) {
    const userData = useSelector(
        (state: RootState) => state.users.selectedDoctor,
    );
    const { email, roleInClinic, createdAt } = userData;

    return (
        <section className='user_info_container'>
            <div className='section_info'>
                <DescriptionDetailsList
                    title={"Посада"}
                    description={
                        roleInClinic === "doctor" ? "Лікар" : "Адміністратор"
                    }
                    style={{ maxWidth: 194 }}
                />
                <DescriptionDetailsList
                    title={"Дата додавання"}
                    description={createdAt ? formattedDate(createdAt) : ""}
                    style={{ maxWidth: 194 }}
                />
            </div>
            <div className='section_info'>
                <DescriptionDetailsList
                    title={"Електронна пошта"}
                    description={email}
                    style={{ maxWidth: 194 }}
                />
            </div>

            <button
                className='user_info_button edit_button'
                onClick={() => toggleDrawer(true)}
            >
                <img
                    src='/patientdetailspage/edit_intarective.svg'
                    alt='logo edit'
                />
                Редагувати
            </button>
        </section>
    );
}
